<template>
  <!-- <transition name="modal" appear> -->
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div id="passmod">
      <div class="passmod_container">
        <!-- <h1>
            <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報">
        </h1>-->
        <h2>パスワード変更</h2>
        <div name="form-passmod" class="form">
          <div style="display:inline-block;margin-bottom:20px;width:100%">
            <input
              style="margin-bottom:0"
              type="password"
              id="pass"
              placeholder="　現在のパスワード"
              v-model="current_password"
              v-validate="{
                required: true,
                regex: /^[0-9a-zA-Z!&quot;#$%&amp;@'|<>(){}\[\]*+,./_\-~=\;\:\?\^]{6,16}$/,
                min: 6,
                max: 16
              }"
              name="current_password"
              data-vv-as="現在のパスワード"
            />
            <div class="err_message" v-show="errors.has('current_password')">
              パスワードは大文字、小文字、数値、
              <br />
              記号 (`~!@#$%^&amp;*()_+-={}|[]:";'&lt;&gt;?,./)
              <br />
              で6～16文字で入力してください。
            </div>
          </div>
          <!-- <input
            type="password"
            id="pass"
            placeholder="　現在のパスワード"
            v-model="current_password"
            v-validate="'required'"
            name="current_password"
            data-vv-as="現在のパスワード"
          >
          <span class="err_message">{{ errors.first('current_password') }}</span>-->
          <div style="display:inline-block;margin-bottom:20px;width:100%">
            <input
              style="margin-bottom:0"
              type="password"
              id="newpass"
              placeholder="　新しいパスワード"
              v-model="new_password"
              v-validate="{
                required: true,
                regex: /^[0-9a-zA-Z!&quot;#$%&amp;@'|<>(){}\[\]*+,./_\-~=\;\:\?\^]{6,16}$/
              }"
              name="new_password"
              data-vv-as="新しいパスワード"
              ref="password"
            />
            <div class="err_message" v-show="errors.has('new_password')">
              パスワードは大文字、小文字、数値、
              <br />
              記号 (`~!@#$%^&amp;*()_+-={}|[]:";'&lt;&gt;?,./)
              <br />
              で6～16文字で入力してください。
            </div>
          </div>
          <!-- <div class="err_message">{{ errors.first("new_password") }}</div> -->

          <div style="display:inline-block;margin-bottom:20px;width:100%">
            <input
              style="margin-bottom:0"
              type="password"
              id="retype"
              placeholder="　新しいパスワード確認入力"
              v-model="new_password_confirm"
              v-validate="'required|confirmed:password|max:16'"
              name="new_password_confirm"
              data-vv-as="新しいパスワード確認入力"
            />
            <div class="err_message">
              {{ errors.first("new_password_confirm") }}
            </div>
          </div>
          <div class="submit_area">
            <input
              type="submit"
              class="submit"
              value="パスワード変更"
              @click="onChange"
            />
            <input
              type="button"
              class="cancel"
              value="キャンセル"
              @click="onCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "password-dialog",
  props: ["account"],
  data: function() {
    return {
      current_password: "",
      new_password: "",
      new_password_confirm: ""
    };
  },
  methods: {
    onCancel: function() {
      // console.log("onCancel");

      this.$emit("close");
    },
    onChange: function() {
      // console.log("onChange");
      this.$validator.validateAll().then(result => {
        // console.log(result);

        if (result) {
          this.changePassword(
            this.account,
            this.current_password,
            this.new_password
          );
        }
      });
    },
    changePassword: function(account, currentPassword, newPassword) {
      const param = {
        current_password: currentPassword,
        new_password: newPassword
      };

      this.$axios
        .put(`/srv/api/password/${account}`, param, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          if (response.data.status == "success") {
            this.$emit("close");
          } else {
            alert("登録できませんでした");
            // console.log(error);
          }
        })
        .catch(error => {
          alert("登録できませんでした");
          console.log(error);
        });
    }
  }
};
</script>

<style>
.modal.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal .modal-window {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.modal .modal-content {
  padding: 10px 20px;
}

.modal .modal-footer {
  background: #ccc;
  padding: 10px;
  text-align: right;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  /* .modal-window {
   transition: opacity 0.4s, transform 0.4s;
 } */
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  /* .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  } */
}
</style>